/////////////// GSAP animation modules (Uncomment required gsap library!) /////////////////
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger"; gsap.registerPlugin(ScrollTrigger);
import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
///////////////////////////////////////////////////////////////////////////////////////////

//// Module summary ////
// ** Explain here what this code does in the project ** // 
// JS code to be executed everywhere on the website
// === A) Enable ScrollSmoother on desktop
// === B) Fade-up animation
// === C) Fade-in animation (fade-in = fade-up + scrollTrigger)
    

export const common = () => {

    // === A) Enable ScrollSmoother on desktop
    // Variables
    let smooth = .5;
  
    //// Mobile verification to enable ScroolSmoother on Desktop
    // Check if mobile (default)
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  
    // Check if mobile (userAgent)
    const mobileLabels = [
      "Android",
      "webOS",
      "iPhone",
      "iPad",
      "iPod",
      "BlackBerry",
      "Windows Phone"
    ];
  
    let userAgentCheck = mobileLabels.some(element => {
      if (navigator.userAgent.includes(element)) {
        return true;
      }
        return false;
      });
  
    // Check if touch device
    let isTouchDevice = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) ? true : false ;
  
    let mobile = false;
    // Check if mobile (userAgentData + all 3 above)
    if (check || userAgentCheck || isTouchDevice) {
      // console.log("Mobile device detected");
      smooth = 0;
      mobile = true;
      // console.log("Mobile basic check > " + check);
      // console.log("Mobile userAgent check > " + userAgentCheck);
      // console.log("Mobile touchscreen check > " + isTouchDevice);
      // console.log("Current user agent > " + navigator.userAgent);
    }
  
    // Create the scrollSmoother before any scrollTriggers,
    // do not create it if [data-smoother="false"] is detected
    if (document.querySelector('[data-smoother="false"]')) {
      mobile = true;
      // console.log('ScrollSmoother disabled')
    }
    if (!mobile) {
      let scrollSmoother = ScrollSmoother.create({
        smooth: smooth,
        content: ".scrollSmoother",
        normalizeScroll: true,
        effects: true,
        smoothTouch: 0.1
      });
      // console.log("ScrollSmoother enabled");
    }

    // === A.2) July 2023 Cookies update
    // === Disable scrollsmoother if user clicked on cookie param
    document.body.addEventListener('click', () => {
      setTimeout(() => {
        if (document.body.hasAttribute('data-cookie')) {
          scrollSmoother.paused(true);
        }
      }, 100);
    });

    // === B) Fade-up animation
    let fadeUpElements = document.querySelectorAll(
      '[data-gsap*="fadeUp"]'
    );
    if (fadeUpElements) {
      gsap.registerEffect({
        name: "fadeUp",
        effect: (target) => {
          return gsap.from(target, {
            yPercent: 50,
            autoAlpha: 0,
            skewY: 10,
            transformOrigin: "left top",
            ease: "power3.out",
            duration: 1.3
          });
        }
      });
      
      for (let current of fadeUpElements) {
        gsap.set(current, { autoAlpha: 1 });
        gsap.effects.fadeUp(current);
      }
    }
    // === C) Fade-in animation (fade-in = fade-up + scrollTrigger)
    let fadeInElements = document.querySelectorAll(
      '[data-gsap*="fadeIn"]'
    );

    if (fadeInElements) {
      gsap.registerEffect({
        name: "fadeIn",
        effect: (target) => {
          return gsap.from(target, {
            scrollTrigger: {
              trigger: target,
              start: "top bottom+=100",
            },
            yPercent: 50,
            autoAlpha: 0,
            skewY: 10,
            transformOrigin: "left top",
            ease: "power3.out",
            duration: 1.3
          });
        }
      });
      
      for (let current of fadeInElements) {
        gsap.set(current, { autoAlpha: 1 });
        gsap.effects.fadeIn(current);
      }
    }
  
  return;
}
